import React from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import usePrivate from '@afosto/auth-react/usePrivate';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import ProfileInformation from './ProfileInformation/ProfileInformation';
import ProfileSecurity from './ProfileSecurity/ProfileSecurity';
import Page from '@afosto/app-components-react/Page';
import translations from './translations';

const Profile = () => {
  usePrivate();

  const history = useHistory();
  const intl = useIntl();
  const location = useLocation();

  return (
    <Page
      title={intl.formatMessage(translations.title)}
      subNavigation={{
        current: location.pathname,
        tabs: [
          {
            label: intl.formatMessage(translations.subNavigation.information),
            path: `/profile`,
          },
          {
            label: intl.formatMessage(translations.subNavigation.security),
            path: `/profile/security`,
          },
        ],
        onChange: (e, value) => history.replace(value),
      }}
    >
      <Switch>
        <Route path="/profile/security" component={ProfileSecurity} />
        <Route path="/profile" component={ProfileInformation} />
      </Switch>
    </Page>
  );
};

export default Profile;
